import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { StoneImportRequest } from '@nucleus-commerce/api-client/platform';

import { diamondsApi } from '../api/diamonds-api';

import { diamondKeys } from './diamond-keys';

/** A 200 can still carry bad rows; the dialog lists them, so only transport errors are toasted. */
export function useImportStones() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: StoneImportRequest) => diamondsApi.importStones(input),
    meta: { silentError: true },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: diamondKeys.stones() }),
  });
}
